import { useExtendWithSubnetworks } from "@l2r-front/l2r-networks"

import { API_MODULE_RISK_ZONE } from "../../../../common/constants/modules"

import { riskZonesQueryKeys } from "./queryKeys"
import { useRiskZonesQuery } from "./useRiskZonesQueries"

export function useRiskZoneGrades(params = {}, config = {}) {
    const url = "risk_zone_clusters/stats/average_grade/"

    const parameters = useExtendWithSubnetworks(params, API_MODULE_RISK_ZONE)
    const queryKey = riskZonesQueryKeys["grades"](parameters)

    return useRiskZonesQuery(
        url,
        queryKey,
        parameters,
        config,
    )
}